import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from '@/router'
import store from '@/store'

import '@/assets/style/index.scss' // eslint-disable-line

Vue.config.productionTip = false
Vue.use(ElementUI);

import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
    ak: 'KT926SMZaaQytozZxScbKduVYCnmeCyb'
})
import '@/assets/js/rem'
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
